import React from 'react';
import './Modal.css';

export function Modal({ show, button, children, title, buttonName, close }) {
	return (
		<div
			className='modal-wrapper'
			style={{
				transition: show
					? 'opacity 0.3s linear'
					: 'visibility 0s 0.3s, opacity 0.3s linear',
				visibility: show ? 'visible' : 'hidden',
				opacity: show ? '1' : '0',
			}}
		>
			<div className='modal-header'>
				<p>{title}</p>
				<span onClick={close} className='close-modal-btn'>
					x
				</span>
			</div>
			<div className='modal-content'>
				<div className='body'>
					<p>{children}</p>
				</div>
				{buttonName && (
					<div className='modal-footer'>
						<button onClick={button} className='btn-cancel'>
							{buttonName}
						</button>
					</div>
				)}
			</div>
		</div>
	);
}

export default Modal;
